import Vue from 'vue'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.min.css'
import 'element-ui/lib/theme-chalk/display.css'
import ElementUI from 'element-ui'
import axios from 'axios'
import router from './router'
import store from './store'
import qs from 'qs'
import './style/reset.css'
import './style/main.css'
import QRCode from 'qrcode'

Vue.config.productionTip = false;
Vue.use(ElementUI)
Vue.use(QRCode)
Vue.prototype.$imgUrl = 'https://exhibitor.larspring.com/';
Vue.prototype.$imgWxOssUrl = 'https://wx.larspring.com/';
Vue.prototype.$imgOssUrl = 'https://oss.larspring.com/pharmchina/';
Vue.prototype.$Url = 'https://exhibitor.larspring.com/exhibitor/upload/image';
Vue.prototype.$fileUrlImportBadge = 'https://exhibitor.larspring.com/exhibitor/badge/importBadge';
Vue.prototype.$fileUrlImportCustomerBadge = 'https://exhibitor.larspring.com/exhibitor/customer_badge/importCustomerBadge';
Vue.prototype.$qs = qs;
Vue.prototype.$axios = axios;
axios.defaults.withCredentials =true;
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
router.beforeEach((to, from, next) => {
  if(to.query.source){
    localStorage.setItem('source',to.query.source)
  }
  //获取用户登录成功后储存的登录标志
  let getFlag = localStorage.getItem("Flag");
  //如果登录标志存在且为isLogin，即用户已登录
  if(getFlag === "isLogin"){
   console.log('登录')
    //设置vuex登录状态为已登录
    store.state.isLogin = true
    next()
  //如果登录标志不存在，即未登录
  }else{
    console.log('未登录')
    //用户想进入需要登录的页面，则定向回登录界面
    if(to.meta.isLogin){
      next({
        path: '/login',
      })
    //用户进入无需登录的界面，则跳转继续
    }else{
      next()
    }
  }
});
router.afterEach(route => {
  window.scroll(0, 0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

//rem计算
function setRem() {
  var whdef = 100/750;// 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth;// 当前窗口的宽度
  var rem = bodyWidth * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
}
//console.log(document.body.clientWidth)
// if(document.body.clientWidth > 750){
//   window.addEventListener('load', setRem);
//   window.addEventListener('resize', setRem);
// }
